import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "unsupported-attributes"
    }}>{`Unsupported Attributes`}</h1>
    <p>{`The following global attributes are unsupported.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`accesskey`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`aria*`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`autocapitalize`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`contenteditable`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`contextmenu`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dir`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dropzone`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`hidden`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`inputmode`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`is`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`item*`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`part`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`spellcheck`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`tabindex`}</inlineCode>{` (supported, but does not match the specification. Negative values are not focused, and positive values will allow focus, but tab order cannot be specified.)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`translate`}</inlineCode></li>
    </ul>
    <p>{`Along with the above items, most event handlers should be attached using `}<inlineCode parentName="p">{`addEventListener`}</inlineCode>{` instead of their `}<inlineCode parentName="p">{`on*`}</inlineCode>{` counterparts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      